import {
  Box,
  Card,
  CardContent,
  TextField,
  Typography,
  CircularProgress,
  Button,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { Page } from "src/components";
import { WithdrawBoolean } from "src/DAL/Wallet";

const WithdrawActive = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [userId, setUserId] = useState("");
  const [userLoading, setUserLoading] = useState(false);
  const [data, setData] = useState(false);

  const handleSubmit = async () => {
    if (!userId.trim()) {
      enqueueSnackbar("Please enter a User UID", { variant: "info" });
      return;
    }

    setUserLoading(true);
    const payload = {
      withdraw_active: data,
      uid: userId,
    };

    try {
      const resp = await WithdrawBoolean(payload);

      if (resp?.status === true) {
        enqueueSnackbar(resp?.message || "Status updated successfully!", {
          variant: "success",
        });
        setUserId("");
        setData(false);
      } else {
        enqueueSnackbar(resp?.message || "Failed to update status", {
          variant: "error",
        });
      }
    } catch (error) {
      enqueueSnackbar(error?.message || "An unexpected error occurred", {
        variant: "error",
      });
    } finally {
      setUserLoading(false);
    }
  };

  return (
    <Page title="Add Balance">
      <Box
        sx={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Card
          sx={{
            width: "100%",
            maxWidth: 460,
            borderRadius: 3,
            boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
          }}
        >
          <CardContent>
            <Typography
              variant="h6"
              fontWeight="bold"
              textAlign="center"
              mb={3}
            >
              Withdraw Active
            </Typography>

            <TextField
              fullWidth
              label="User UID"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              disabled={userLoading}
              sx={{ mb: 2 }}
            />

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 3,
                px: 1,
              }}
            >
              <Typography variant="body1" fontWeight={500}>
                Withdraw Status
              </Typography>
              <FormControlLabel
                control={
                  <Switch
                    checked={data}
                    onChange={(e) => setData(e.target.checked)}
                    disabled={userLoading}
                    color="primary"
                  />
                }
                label={data ? "Active" : "Inactive"}
              />
            </Box>

            <Button
              fullWidth
              variant="contained"
              onClick={handleSubmit}
              disabled={userLoading}
              sx={{
                height: 44,
                borderRadius: 2,
                fontWeight: 600,
              }}
            >
              {userLoading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Submit"
              )}
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Page>
  );
};

export default WithdrawActive;
